import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import img50 from "../../assets/50.png";
import img69 from "../../assets/69.png";
import img79 from "../../assets/79.png";
import img81 from "../../assets/81.png";

function Team() {
  const nfts = [
    {
      image: img50,
      name: "Decentra",
      desc: "Project Leader",
      twitter: "https://twitter.com/Decentra18",
    },
    {
      image: img69,
      name: "Militia",
      desc: "Developer",
      twitter: "https://twitter.com/OlaoluwaOjedapo",
    },
    {
      image: img79,
      name: "TheImmutable",
      desc: "Marketer",
      twitter: "https://twitter.com/TheImmutable_",
    },
    {
      image: img81,
      name: "ValleyCrypto",
      desc: "Community Manager",
      twitter: "https://twitter.com/jesva0711",
    },
  ];

  return (
    <section
      className="container project_container"
      id="nftproject"
      style={{
        margin: "60px auto",
      }}
    >
      <h2>MonkeyDoo Team</h2>

      <div
        className="image_cards team"
        style={{
          display: "grid",
          gridGap: "1rem",
          gap: "1rem",
        }}
      >
        {nfts.map((nft, i) => (
          <article className="image_card" key={i}>
            <img
              src={nft.image}
              style={{
                padding: "15px",
              }}
            />
            <div className="card_text">
              <h3
                style={{
                  textAlign: "center",
                }}
              >
                {nft.name}
              </h3>
              <h5
                style={{
                  textAlign: "center",
                }}
              >
                {nft.desc}
              </h5>
            </div>
            <div
              style={{
                marginTop: "20px",
              }}
            >
              <a href={nft.twitter} target="_blank">
                <i
                  className="fa fa-twitter"
                  style={{
                    color: "rgb(255, 119, 155)",
                    fontSize: "30px",
                    margin: "5px",
                  }}
                ></i>
              </a>
              {/* <a href="#" target="_blank">
                <i
                  className="fa fa-discord"
                  style={{
                    color: "rgb(255, 119, 155)",
                    fontSize: "30px",
                    margin: "5px",
                  }}
                ></i>
              </a> */}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Team;
